import { Box, Grid, TextField, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { isEmpty, isNil } from "lodash";
import React from "react";

import HarvestAPI from "../api/Harvest.api";
import { Harvest, HarvestInput } from "../types";
import Autosave from "./Autosave";
import CultivationList from "./CultivationList";
import GroundPrepSelect from "./GroundPrepSelect";
import HarvestFieldWorkReportTabPreliminaryWork from "./HarvestFieldWorkReportTabPreliminaryWork";
import HoeDateList from "./HoeDateList";

type Props = {
  harvest: Harvest;
};
export default function HarvestFieldWorkReportTab({ harvest }: Props) {
  const [thinningDate, setThinningDate] = React.useState<Dayjs | null>(
    harvest.thinningDate ? dayjs(harvest.thinningDate) : null,
  );
  const [numOfInchesAdded, setNumOfInchesAdded] = React.useState<number>(
    harvest.numOfInchesAdded ? harvest.numOfInchesAdded : 0,
  );

  const harvestInput: HarvestInput = {
    id: harvest.id,
    thinningDate: thinningDate
      ? thinningDate?.format("YYYY-MM-DD")
      : thinningDate,
    numOfInchesAdded,
  };

  const { mutateAsync } = HarvestAPI.useUpdateAuto();

  return (
    <Box
      sx={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <Autosave
        data={harvestInput}
        patchApiCall={mutateAsync}
        showPopup={true}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Typography variant="body1">
          Info explaining to the user what this phase is about and when to add
          items here.
        </Typography>
      </Box>
      <HarvestFieldWorkReportTabPreliminaryWork
        harvest={harvest}
        disabled={isNil(harvest.preliminaryWorkId)}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <GroundPrepSelect
            groundPrepAttachments={
              harvest?.preliminaryWork?.groundPrepAttachments
            }
            groundPrepAttachableType={"PreliminaryWork"}
            groundPrepAttachableId={harvest.preliminaryWorkId}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <DatePicker
            label="Thinning Date"
            value={thinningDate}
            onChange={(value) => setThinningDate(value)}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Plant Spacing in Inches"
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
            value={numOfInchesAdded}
            onChange={(e) => {
              const val = e.target.value;
              if (isEmpty(val)) {
                setNumOfInchesAdded(0);
              } else {
                setNumOfInchesAdded(parseInt(val));
              }
            }}
            fullWidth
          />
        </Grid>
      </Grid>

      <HoeDateList harvest={harvest} />
      <CultivationList harvest={harvest} />
    </Box>
  );
}
